/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CapsulePartyEntry } from '../../models/capsule-party-entry';

export interface MgmtCustomerControllerCapsuleEntries$Params {
  partyId: number;
}

export function mgmtCustomerControllerCapsuleEntries(http: HttpClient, rootUrl: string, params: MgmtCustomerControllerCapsuleEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyEntry>>> {
  const rb = new RequestBuilder(rootUrl, mgmtCustomerControllerCapsuleEntries.PATH, 'get');
  if (params) {
    rb.path('partyId', params.partyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CapsulePartyEntry>>;
    })
  );
}

mgmtCustomerControllerCapsuleEntries.PATH = '/api/mgmt-customers/capsule/{partyId}/entries';
